import { createFileRoute } from "@tanstack/react-router";
import PrivacyPolicy from "@/pages/PrivacyPolicy";

export const Route = createFileRoute("/privacy")({
  head: () => ({
    meta: [
      { title: "Privacybeleid – De Hussel App" },
      { name: "description", content: "Lees het privacybeleid van De Hussel App. Hoe wij omgaan met je persoonsgegevens en data." },
      { property: "og:title", content: "Privacybeleid – De Hussel App" },
      { property: "og:description", content: "Lees het privacybeleid van De Hussel App. Hoe wij omgaan met je persoonsgegevens en data." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://dehusselapp.nl/privacy" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://dehusselapp.nl/privacy" }],
  }),
  component: PrivacyPolicy,
});
